import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	media: {
		results: [],
		error: '',
		isLoading: false,
		hasBeenLoaded: false,
		total: 0
	},
	processingMedia: {
		results: [],
		error: '',
		isLoading: false,
		hasBeenLoaded: false,
		total: 0
	},
	stagedMedia: {
		results: [],
		error: '',
		isLoading: false,
		hasBeenLoaded: false,
		total: 0
	},
	stagedMediaCount: {
		total: 0,
		error: '',
		isLoading: false,
		hasBeenLoaded: false
	},
	stagedMediaDetail: {
		data: {},
		error: '',
		isLoading: false,
		hasBeenLoaded: false
	}
};

export const mediaSlice = createSlice({
	name: 'media',
	initialState,
	reducers: {
		getMedia: (state) => {
			state.media.isLoading = true;
		},
		getMediaCompleted: (state, action) => {
			state.media.isLoading = false;
			state.media.total = action.payload.total;
			state.media.results = action.payload.results;
			state.media.hasBeenLoaded = true;
			state.media.error = '';
		},
		getMediaFailed: (state, action) => {
			state.media.isLoading = false;
			state.media.hasBeenLoaded = false;
			state.media.error = action.payload;
		},
		getProcessingMedia: (state) => {
			state.processingMedia.isLoading = true;
		},
		getProcessingMediaCompleted: (state, action) => {
			state.processingMedia.isLoading = true;
			state.processingMedia.total = action.payload.total;
			state.processingMedia.results = action.payload.results;
			state.processingMedia.hasBeenLoaded = true;
			state.processingMedia.error = '';
		},
		getProcessingMediaFailed: (state, action) => {
			state.processingMedia.isLoading = false;
			state.processingMedia.hasBeenLoaded = false;
			state.processingMedia.error = action.payload;
		},
		getStagedMedia: (state) => {
			state.stagedMedia.isLoading = true;
		},
		getStagedMediaCompleted: (state, action) => {
			state.stagedMedia.isLoading = true;
			state.stagedMedia.total = action.payload.total;
			state.stagedMedia.results = action.payload.results;
			state.stagedMedia.hasBeenLoaded = true;
			state.stagedMedia.error = '';
		},
		getStagedMediaFailed: (state, action) => {
			state.stagedMedia.isLoading = false;
			state.stagedMedia.hasBeenLoaded = false;
			state.stagedMedia.error = action.payload;
		},
		getStagedMediaCount: (state) => {
			state.stagedMediaCount.isLoading = true;
		},
		getStagedMediaCountCompleted: (state, action) => {
			state.stagedMediaCount.isLoading = false;
			state.stagedMediaCount.total = action.payload.total;
			state.stagedMediaCount.hasBeenLoaded = true;
			state.stagedMediaCount.error = '';
		},
		getStagedMediaCountFailed: (state, action) => {
			state.stagedMediaCount.isLoading = false;
			state.stagedMediaCount.hasBeenLoaded = false;
			state.stagedMediaCount.error = action.payload;
		},
		getStagedMediaDetail: (state) => {
			state.stagedMediaDetail.isLoading = true;
			state.stagedMediaDetail.hasBeenLoaded = false;
		},
		getStagedMediaDetailCompleted: (state, action) => {
			state.stagedMediaDetail.isLoading = false;
			state.stagedMediaDetail.data = action.payload;
			state.stagedMediaDetail.hasBeenLoaded = true;
			state.stagedMediaDetail.error = '';
		},
		getStagedMediaDetailFailed: (state, action) => {
			state.stagedMediaDetail.isLoading = false;
			state.stagedMediaDetail.hasBeenLoaded = false;
			state.stagedMediaDetail.error = action.payload;
		}
	}
});

export const {
	getMedia,
	getMediaCompleted,
	getMediaFailed,
	getProcessingMedia,
	getProcessingMediaCompleted,
	getProcessingMediaFailed,
	getStagedMedia,
	getStagedMediaCompleted,
	getStagedMediaFailed,
	getStagedMediaCount,
	getStagedMediaCountCompleted,
	getStagedMediaCountFailed,
	getStagedMediaDetail,
	getStagedMediaDetailCompleted,
	getStagedMediaDetailFailed
} = mediaSlice.actions;

export default mediaSlice.reducer;
